module.exports = __webpack_public_path__ + "img/Monte_Kope_45.56a3343b.jpg";